import useCrashReporting from './useCrashReporting';

/**
 * This hook enables the crash recovery logic.
 *
 * This addresses an iOS issue (WEB-12656) where rendering too many elements causes
 * the webview to crash. (our best guess is that this is due to running out of memory)
 *
 */
export default function useCrashRecovery() {
    useCrashReporting(); // receive data from Capacitor about crashes
}
